"use client";

import { useState } from "react";
import { VouchModal } from "./VouchModal";

/**
 * Keeps the peer vouch flow working for signed-in candidates who only see the
 * profile teaser. Vouching never unlocks the full profile.
 */
export function TeaserVouchButton({
  firstName,
  voucheeUserId,
  initiallyVouched,
}: {
  firstName: string;
  voucheeUserId: string;
  initiallyVouched: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [vouched, setVouched] = useState(initiallyVouched);

  if (vouched) {
    return (
      <p className="inline-flex min-h-11 items-center rounded-[10px] bg-[#E8F5E9] px-4 text-[14px] font-semibold text-success">
        You&apos;ve vouched for {firstName}
      </p>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex min-h-11 items-center justify-center rounded-[8px] border border-teal/30 bg-teal/10 px-5 text-[14px] font-semibold text-teal-dark transition-colors hover:bg-teal/15"
      >
        Vouch for {firstName}
      </button>
      {open && (
        <VouchModal
          candidateName={firstName}
          voucheeId={voucheeUserId}
          onClose={() => setOpen(false)}
          onVouched={() => {
            setVouched(true);
            setOpen(false);
          }}
        />
      )}
    </>
  );
}
